/** Orchestrator (and any connector that can discover): project → agent slug → version.
 *  A target with a `label` (its name when the slug is an id) names its agent. */

import { GenericRunSettingsForm } from "../run-settings-form";
import type { PlatformScreens } from "../screens";
import { DiscoverTargetPicker } from "./target-picker";

export const orchestratorScreens: PlatformScreens = {
  TargetPicker: DiscoverTargetPicker,
  RunSettingsForm: GenericRunSettingsForm,
  discovers: true,
  fromRef: (ref) => (typeof ref["project_id"] === "string" ? { group: ref["project_id"] } : {}),
  ready: (t) => !!t.group && !!t.target,
  payload: (t) => ({
    group: t.group ?? "",
    target: t.target ?? "",
    version: t.version,
    ...(t.agentName ? { agent_name: t.agentName } : {}),
  }),
};
